<nz-card>

<form [formGroup]="settingsForm">
<h2>Settings</h2>
  <nz-form-item>
    <nz-form-label nzFor="name" nzRequired>Name</nz-form-label>
    <nz-form-control
        [nzErrorTip]="getFieldError('name')"
      [nzValidateStatus]="isFieldInvalid('name') ? 'error' : ''">
      <input nz-input id="name" formControlName="name" placeholder="Enter name" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label nzFor="tel" nzRequired>Telephone</nz-form-label>
    <nz-form-control
        [nzErrorTip]="getFieldError('tel')"
      [nzValidateStatus]="isFieldInvalid('tel') ? 'error' : ''">
      <input nz-input id="tel" formControlName="tel" placeholder="Enter telephone" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>Standard Delay Time (mins)</nz-form-label>
    <nz-form-control [nzSpan]="8" >
      <nz-input-number formControlName="standardDelayTimeMins" [nzMin]="0" [nzStep]="1" style="width: 100%;"></nz-input-number>
    </nz-form-control>
  </nz-form-item>

  <div formGroupName="address">
    <h3 style="margin-top: 24px; margin-bottom: 16px;">Address</h3>
    <nz-form-item>
      <nz-form-label nzFor="city">City</nz-form-label>
      <nz-form-control>
        <input nz-input id="city" formControlName="city" placeholder="Enter city" />
      </nz-form-control>
    </nz-form-item>
    <nz-row [nzGutter]="16">
        
      <nz-col [nzSpan]="8">
        <nz-form-item>
          <nz-form-label nzFor="lat" nzRequired>Latitude</nz-form-label>
          <nz-form-control
            [nzErrorTip]="getFieldError('address.lat')"
            [nzValidateStatus]="isFieldInvalid('address.lat') ? 'error' : ''">
            <input nz-input id="lat" formControlName="lat" placeholder="Enter latitude" />
          </nz-form-control>
        </nz-form-item>
      </nz-col>
      
      <nz-col [nzSpan]="8">
        <nz-form-item>
          <nz-form-label nzFor="lon" nzRequired>Longitude</nz-form-label>
          <nz-form-control
            [nzErrorTip]="getFieldError('address.lon')"
            [nzValidateStatus]="isFieldInvalid('address.lon') ? 'error' : ''">
            <input nz-input id="lon" formControlName="lon" placeholder="Enter longitude" />
          </nz-form-control>
        </nz-form-item>
      </nz-col>
      <nz-col [nzSpan]="8">
            <nz-form-item>
            <nz-form-control>
                <button nz-button nzType="default" (click)="findLocation()">
                <span nz-icon nzType="environment" nzTheme="outline"></span>
                Find Exact Location
                </button>
            </nz-form-control>
            </nz-form-item>
        </nz-col>
    </nz-row>


    <app-map-select 
      [mapMarkerLocation]="location"
      (locationSelected)="onMapLocationSelected($event)"
    ></app-map-select>

  </div>

  <nz-form-item style="margin-top: 24px;">
    <nz-form-control>
      <button nz-button nzType="primary" (click)="saveSettings()" [disabled]="settingsForm.invalid || isLoading || !settingsForm.dirty">
        <span nz-icon nzType="save" nzTheme="outline"></span>
        Save Settings
      </button>
    </nz-form-control>
  </nz-form-item>
</form>   
</nz-card>
